export default "__VITE_ASSET__BrtO2OaT__"